import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description: 'In order to close this wallet, the balance must be €0. ',
    title: 'Money left in {name}',
    transferBalance: 'Transfer the remaining balance',
  },
  fr: {
    description:
      'Afin de clôturer ce compte, le solde doit être à 0 €.\nVous pouvez transférer instantanément le solde restant vers un autre compte.',
    title: 'Il reste de l’argent sur {name}',
    transferBalance: 'Transférer le solde restant',
  },
} as const);

export default locales;
